import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

const DeterminedControllerNamePropsSchema = z.object({
  determinedControllerNameValue: z.string(),
})

type DeterminedControllerNameProps = z.infer<
  typeof DeterminedControllerNamePropsSchema
>

export class DeterminedControllerName extends ValueObject<DeterminedControllerNameProps> {
  public getValue(): string {
    return this.props.determinedControllerNameValue
  }

  public static create(
    props: DeterminedControllerNameProps
  ): DeterminedControllerName {
    const validatedProps = DeterminedControllerNamePropsSchema.parse(props)
    return new DeterminedControllerName(validatedProps)
  }
}
